import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-email-alerts-intro-dialog',
  templateUrl: './email-alerts-intro-dialog.component.html',
  styleUrls: ['./email-alerts-intro-dialog.component.scss'],
})
export class EmailAlertsIntroDialogComponent {}
